<template>
  <Layout title="404" subTitle="Oops! Sorry we can't find that page." description="Either something went wrong or the page doesn't exist anymore.">
    <h1 class="title">
      <template v-if="resource">
        {{ resource }}
      </template>
    </h1>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Landing.vue'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
